// @flow
import { connect } from 'react-redux'
import SwitchableProviderPreview, { type Props } from './SwitchableProviderPreview'
import _ from 'lodash'
import { getAdvertisementWithMedia, getReplicaAdvertisementWithMedia } from '../../redux/selectors'
import type { Store } from '../../redux/ducks'
import type { AudienceData, ValidatedAdvertisement } from '../types'
import prepareDataForPreview from './ProviderPreviews/prepareDataForPreview'

type OwnProps = {|
  audienceData: AudienceData,
  storeIds: Array<string>
|}

function mapStateToProps(state: Store, ownProps) {
  const { storeIds, audienceData } = ownProps
  const replicas = state.advertisementReplicas

  const firstAd: ?ValidatedAdvertisement = storeIds[0]
    ? getAdvertisementWithMedia(state, storeIds[0])
    : null
  const replicaAds: Array<ValidatedAdvertisement> = firstAd
    ? _.map(replicas, (_replica, index: number) => {
        return getReplicaAdvertisementWithMedia(state, storeIds[0], index)
      })
    : []
  const ads: Array<ValidatedAdvertisement> = [...(firstAd ? [firstAd] : []), ...replicaAds]
  return {
    previewDataCollection: _.map(ads, (advertisement) =>
      prepareDataForPreview({ audienceData, advertisement })
    )
  }
}

const SwitchableProviderPreviewContainer = connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(
  SwitchableProviderPreview
)

export default SwitchableProviderPreviewContainer
